import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SOCKET_TIMEOUT } from '@app/core/constants/payment-constants';
import { LoadingService } from '@app/core/services/loading/loading.service';
import { LoginAccountService } from '@app/core/services/login-account/login-account.service';
import { SharedService } from '@app/core/services/shared/shared.service';
import { SocketService } from '@app/core/services/socket/socket.service';
import { ToastService } from '@app/core/services/toast/toast.service';
import { LoginAccount } from '@app/shared/models/loginAccount';
import { ModalController, NavParams } from '@ionic/angular';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.page.html',
  styleUrls: ['./user-login.page.scss'],
  standalone: false,
})
export class UserLoginPage implements OnInit, OnDestroy {
  modalHeader: string;
  cardNumberLabel: string;
  pinNumberLabel: string;

  form: FormGroup;
  submitted = false;
  optionsLength: number = 1;
  pinBox: boolean = true;
  rememberMe: boolean = false;
  defaultAccount: LoginAccount = null;
  accountName: string = '';
  disableRememberMe: boolean = false;
  isOldNumberChanged: boolean = false;
  private subscription: Subscription = new Subscription();

  constructor(
    private modalCtrl: ModalController,
    private socketSvc: SocketService,
    private loadingSvc: LoadingService,
    private toastSvc: ToastService,
    private navParams: NavParams,
    private sharedSvc: SharedService,
    private loginAccountService: LoginAccountService
  ) {
    this.optionsLength = this.navParams.get('optionsCount');
    this.pinBox = this.navParams.get('pinBox') ?? true;
    this.defaultAccount = this.navParams.get('defaultAccount') ?? null;
    this.accountName = this.defaultAccount.account ?? '';
    let pinBoxValidation = [Validators.required];
    if (!this.pinBox) {
      pinBoxValidation = [];
    }
    if (this.defaultAccount) {
      this.disableRememberMe = true;
      this.rememberMe = true;
    } else {
      this.disableRememberMe = false;
      this.rememberMe = false;
    }

    this.form = new FormGroup({
      cardnum: new FormControl(this.accountName, {
        updateOn: 'change',
        validators: [Validators.required],
      }),
      pin: new FormControl('', {
        updateOn: 'change',
        validators: pinBoxValidation,
      }),
    });
    this.socketSvc.connect();
  }
  onChangeCardNumer(event) {
    const root = document.querySelector(':root');
    if (event.target.value && event.target.value === this.accountName) {
      root['style'].setProperty('--library-card-text-color', '#c3c3c6');
      this.disableRememberMe = true;
      this.rememberMe = true;
    } else {
      root['style'].setProperty('--library-card-text-color', '#000000');
      this.disableRememberMe = false;
      this.rememberMe = false;
    }
  }

  async ngOnInit() {
    this.subscription.add(
      this.socketSvc.messages.subscribe(async (msg) => {
        this.submitted = false;
        await this.subscriptionData(msg);
        await this.loadingSvc.dismiss();
      })
    );
  }
  async setFormValidations() {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.socketSvc.disconnect();
  }

  async onSubmit() {
    try {
      this.submitted = true;
      await this.sendMsg();
      setTimeout(async () => {
        if (this.submitted) {
          await this.toastSvc.presentToast(
            'SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN'
          );
          this.submitted = false;
          this.form.controls.pin.reset();
        }
      }, SOCKET_TIMEOUT);
      // this.modalCtrl.dismiss(this.form.controls.cardnum.value);
      // if (this.submitted || !this.form.valid) {

      //   //return;
      // }
      // this.submitted = true;
    } catch (error) {}
  }
  onReset() {
    this.modalCtrl.dismiss(null, 'cancel');
  }

  async onClose() {
    // this.modalCtrl.dismiss();
  }

  private async sendMsg() {
    await this.loadingSvc.present();
    const cardNumber = this.form.controls.cardnum.value;

    const message = {
      action: 'sendmessage',
      body: {
        actionItem: 'lmsValidateSession',
        tier: 'standard', //localStorage.getItem('Tier'),
        requestType: 'lmsvalidate',
        locationId: this.sharedSvc.getCustomerDetails.customizationsText
          .LocationHoursSection.LocationSelectionRequired
          ? this.sharedSvc.domaininfo.locationId
          : '',
        customerId: this.sharedSvc.getCustomerDetails.customizations.CustomerID, //localStorage.getItem('customerId'),
        cardNumber,
        pin: this.form.controls.pin.value,
        url: 'https://todaysbusiness.solutions/kapi/LMSValidate/LoginUser', //localStorage.getItem('URL'),
      },
    };
    // this.sent.push(message);
    this.socketSvc.messages.next(message);
  }

  private async subscriptionData(msg) {
    if (!msg.lmsValidated) {
      this.form.controls.pin.reset();
      await this.toastSvc.presentToast(msg.message);
    } else {
      if (
        this.rememberMe &&
        this.form.controls.cardnum.value != this.accountName
      ) {
        const newAccount: LoginAccount = {
          account: this.form.controls.cardnum.value,
          description: 'Default',
          default: true,
        };
        if (!this.defaultAccount.lmsValidated) {
          newAccount.lmsValidated = true;
        }
        this.loginAccountService.create(newAccount);
      } else {
        if (this.defaultAccount && !this.defaultAccount?.lmsValidated) {
          this.setLibraryValidationAccount();
        }
      }

      await this.modalCtrl.dismiss(this.form.controls.cardnum.value);
    }
  }

  async setLibraryValidationAccount() {
    const accounts = await this.loginAccountService.read();
    accounts.forEach((acc, index) => {
      if (acc.default) {
        acc.lmsValidated = true;
        this.loginAccountService.updateSingleRow(acc, index);
      }
    });
  }

  rememberMeHandler() {
    this.rememberMe = !this.rememberMe;
  }
}
